import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { FieldTrackingConfig } from '../../../../config/eev-form-tracking.config';
import { EventTrackingService } from '../../../../services/event-tracking.service';
import { FieldInteraction } from '../../../../models/event-data.model';
import { AuthEventType } from '../../../../enums/event/event.enum';

@Component({
    selector: 'app-be-select-reactive',
    templateUrl: './be-select-reactive.component.html',
    styleUrls: ['./be-select-reactive.component.scss'],
    standalone: false
})
export class BeSelectReactiveComponent implements OnInit {
  @Input() beFormGroup: UntypedFormGroup;
  @Input() beFormControl: UntypedFormControl;
  @Input() beFormControlName: string;
  @Input() label: string;
  @Input() isFormSubmitted?: boolean;
  @Input() placeholder?: string;
  @Input() options: any[];
  @Input() optionKey?: string;
  @Input() optionTemplate?: TemplateRef<any>;
  @Input() eevTrackingConfig: FieldTrackingConfig;

  selectedOptionIndex: number;
  private readonly ngUnsubscribe$: Subject<boolean> = new Subject();
  private firstInteractionTracked: boolean = false;

  constructor(private eventTrackingService: EventTrackingService) {}

  ngOnInit() {
    if (this.beFormControl && this.eevTrackingConfig) {
      this.beFormControl.valueChanges.pipe(take(1)).subscribe(() => {
        this.eventTrackingService.trackEvent<FieldInteraction>(
          AuthEventType.FIELD_INTERACTION,
          this.eevTrackingConfig.event
        );
      });
    }
    // handle default values
    if (this.beFormControl.value) {
      this.selectedOptionIndex = this.getSelectedOptionIndex();
    }
    this.beFormControl.valueChanges.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(() => {
      this.selectedOptionIndex = this.getSelectedOptionIndex();
    });
  }
  getSelectedOptionIndex() {
    return this.options.findIndex((option) =>
      this.optionKey
        ? option[this.optionKey] === this.beFormControl?.value?.[this.optionKey]
        : option === this.beFormControl?.value
    );
  }
  ngOnDestroy() {
    this.ngUnsubscribe$.next(null);
    this.ngUnsubscribe$.complete();
  }
}
